import * as React from "react";
import {Component } from "react";

import "./footer.scss";
import {observer} from "mobx-react";

@observer
export class ObjektwesenFooter extends Component<any> {
    render(): JSX.Element | null {
        return(
            <footer className="footer">
                <div className="footer__content">
                    <ul className="footer__content-linklist">
                        <li className="footer__content-link-item">
                            <a className="footer__content-link" href="https://geoportal.lu.ch/">
                                © {new Date().getFullYear()} Kanton Luzern</a><span className="line" />
                        </li>
                        <li className="footer__content-link-item">
                            <a className="footer__content-link" title="Disclaimer"
                                href="https://geoportal.lu.ch/Disclaimer"
                                rel={"noreferrer"} target="_blank">Disclaimer</a>
                        </li>
                    </ul>
                </div>
            </footer>
        );
    }
}
